
    export default {
    name: 'layoutDefault',
    components: {
    },
    data () {
          return {
            titulo: 'Banco da Amazônia'
          }
        }
    }
